import { useTranslation } from 'react-i18next';

import { Button, Typography } from '@/shared/components/atoms';

import CheckMarkWithoutBG from '~/images/shared/CheckMarkWithoutBG.svg';
const AddingCrewMemberSuccessModal: React.FC<{
  addAnotherHandlerFunction: () => void;
  actionHandlerFunction: () => void;
  crewType: 'crew' | 'worker';
}> = ({ actionHandlerFunction, addAnotherHandlerFunction, crewType }) => {
  const { t } = useTranslation('common');

  return (
    <div className='flex w-full flex-col items-center justify-center gap-32'>
      <div className='flex h-64 w-64 items-center justify-center rounded-full bg-secondary-90 text-center text-40 text-green-300'>
        <CheckMarkWithoutBG />
      </div>
      <div className='flex w-full flex-col items-center text-center'>
        <Typography variant='h3'>
          {t(crewType === 'crew' ? 'crew-added' : 'worker-added')}
        </Typography>
        <Typography variant='body2' className='w-5/6 text-surface-10'>
          {t(
            crewType === 'crew'
              ? 'crew-added-description'
              : 'worker-added-description'
          )}
        </Typography>
      </div>
      <div className='mt-20 flex w-full flex-grow justify-end gap-16'>
        <Button
          variant='text'
          type='button'
          size='sm'
          className='h-48 w-full'
          onClick={addAnotherHandlerFunction}
        >
          {t(crewType === 'crew' ? 'add-another-crew' : 'add-another-worker')}
        </Button>
        <Button
          variant='filled'
          type='button'
          size='sm'
          className='h-48 w-full !rounded-xl border-xs border-grey-200'
          onClick={actionHandlerFunction}
        >
          {t(crewType === 'crew' ? 'add-workers' : 'create-contract')}
        </Button>
      </div>
    </div>
  );
};

export { AddingCrewMemberSuccessModal };
